import { useMemo, useState, useEffect } from 'react'
import useAxios from 'axios-hooks'

export const useMemberPrograms = () => {
  const [params, setParams] = useState()

  const [
    {
      data: dataMemberPrograms,
      loading: loadingMemberPrograms,
      error: errorMemberPrograms,
    },
    getMemberPrograms,
  ] = useAxios(
    {
      url: 'programs',
      method: 'POST',
      data: params,
    },
    { manual: true }
  )

  useEffect(() => {
    if (params) {
      getMemberPrograms()
    }
  }, [params])

  return useMemo(() => ({
    dataMemberPrograms,
    loadingMemberPrograms,
    errorMemberPrograms,
    getMemberPrograms,
    params,
    setParams,
  }), [
    dataMemberPrograms,
    loadingMemberPrograms,
    errorMemberPrograms,
    getMemberPrograms,
    params,
    setParams,
  ])
}
